import {ExpertRatingsState} from "../types/ExpertRatingsState";

export const state: ExpertRatingsState = {
    sections: [],
    profiles: [],
    criterias: [],
    additionalCriterias: [],
    sectionProjects: [],
    isLoaded: false,
    selected: null,
    ratings: {},
    comments: {},
    summaryComments: {},
    summaryExpertsComments: {},
    summaryExpertRatings: {},
    summaryProjectRatings: {},
    canSaveCurrentSectionRates: false,
    currentSectionRatesSaved: false,
    profileErrorShown: false
}